import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import reportIcon from "../../assets/icons/ascending Copy 50.svg";
import { Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useDispatch } from "react-redux";
import { deleteCustomReport, saveCustomReport } from "./state/actions";
import useSnackBar from "../Hooks/useSnackBar";

const Report = ({ type, report, isCorzapReports }) => {
  const { error, snackbar, success } = useSnackBar();
  const { keycloak } = useKeycloak();
  const userId = keycloak.tokenParsed.preferred_username;

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDuplicate = () => {
    dispatch(
      saveCustomReport(
        userId,
        report.reportName,
        report.reportCriteria,
        null,
        success,
        error
      )
    );
    handleClose();
  };
  const handleDelete = () => {
    dispatch(deleteCustomReport(userId, report.reportName, success, error));
    handleClose();
  };

  return (
    <>
      {snackbar}{" "}
      <Card
        sx={{
          borderRadius: "12px",
          "& .MuiCardContent-root:last-child": { paddingBottom: "15px" },
          cursor: "pointer",
        }}
      >
        <CardContent
          sx={{
            padding: "15px",
          }}
        >
          <Grid container alignItems="center">
            <Grid item sx={{ flexGrow: 1 }}>
              <Link
                to={`/reports/${type}/${report.reportName}`}
                state={{ isCorzapReports }}
                style={{ textDecoration: "none" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="start"
                  alignItems="center"
                >
                  <Grid item>
                    <img
                      src={reportIcon}
                      loading="lazy"
                      alt="report-icon"
                      style={{ width: "44px", height: "44px", color: "red" }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        color: "#050D2E",
                        fontSize: ".875rem",
                        fontWeight: 550,
                        lineHeight: "16px",
                        marginBottom: "5px",
                      }}
                    >
                      {report.reportName}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#050D2E",
                        fontSize: ".813rem",
                        lineHeight: "15px",
                      }}
                    >
                      {report.creationDate}
                    </Typography>
                  </Grid>
                </Grid>
              </Link>
            </Grid>
            <Grid item>
              <IconButton
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <MoreHorizIcon sx={{ color: "#50566E" }} />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={handleDuplicate}>Duplicate</MenuItem>
                {type !== "corzap" && (
                  <MenuItem onClick={handleDelete}>Delete</MenuItem>
                )}
              </Menu>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default Report;
